module.exports = __webpack_public_path__ + "static/media/sairam.ab176838.png";